
import {createContext, useState} from 'react'

const Context = createContext()

export const ClienteContextProvider = ({children}) => {
 const [allClientes, setAllClientes] = useState([]);
 const [vinculedClientes, setVinculedClientes] = useState([]);
 const [clientes, setClientes] = useState([]);
 const [cliente, setCliente] = useState({})
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState({
  message: '',
  status: 200
 })
 return <Context.Provider value={{allClientes, setAllClientes, clientes, setClientes, cliente, setCliente, message, setMessage, loading, setLoading, vinculedClientes, setVinculedClientes}}>
  {children}
 </Context.Provider>
}
export default Context